import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Checkout() {
  const navigate = useNavigate();
  const [selectedAddress, setSelectedAddress] = useState(0);
  const [selectedPayment, setSelectedPayment] = useState(0);
  const [showAddressForm, setShowAddressForm] = useState(false);

  const addresses = [
    {
      id: 1,
      title: 'المنزل',
      address: 'شارع الملك فهد، حي النخيل، الرياض',
      phone: '+966 50 123 4567',
      isDefault: true
    },
    {
      id: 2,
      title: 'العمل',
      address: 'طريق الملك عبدالعزيز، حي العليا، الرياض',
      phone: '+966 50 123 4567',
      isDefault: false
    }
  ];

  const paymentMethods = [
    {
      id: 1,
      type: 'card',
      title: 'بطاقة ائتمانية',
      subtitle: '**** **** **** 1234',
      icon: 'ri-bank-card-line'
    },
    {
      id: 2,
      type: 'cash',
      title: 'الدفع عند الاستلام',
      subtitle: 'ادفع نقداً عند وصول الطلب',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      id: 3,
      type: 'wallet',
      title: 'محفظة إلكترونية',
      subtitle: 'STC Pay, Apple Pay',
      icon: 'ri-wallet-line'
    }
  ];

  const orderSummary = {
    subtotal: 37.00,
    delivery: 5.00,
    total: 42.00
  };

  const handlePlaceOrder = () => {
    navigate('/order-confirmation');
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-32">
      {/* الهيدر */}
      <div className="bg-white shadow-sm">
        <div className="flex items-center justify-between p-4 pt-12">
          <button onClick={() => navigate(-1)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <h1 className="text-lg font-bold">إتمام الطلب</h1>
          <div className="w-10"></div>
        </div>
      </div>

      <div className="px-4 mt-4 space-y-4">
        {/* عنوان التوصيل */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-medium text-gray-800">عنوان التوصيل</h3>
            <button 
              onClick={() => setShowAddressForm(true)}
              className="text-green-500 text-sm font-medium"
            >
              إضافة عنوان
            </button>
          </div>
          
          <div className="space-y-3">
            {addresses.map((address, index) => (
              <div 
                key={address.id}
                className={`p-3 border rounded-lg cursor-pointer ${
                  selectedAddress === index ? 'border-green-500 bg-green-50' : 'border-gray-200'
                }`}
                onClick={() => setSelectedAddress(index)}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 space-x-reverse mb-1">
                      <h4 className="font-medium text-gray-800">{address.title}</h4>
                      {address.isDefault && (
                        <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded">افتراضي</span>
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mb-1">{address.address}</p>
                    <p className="text-sm text-gray-500">{address.phone}</p>
                  </div>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    selectedAddress === index ? 'border-green-500' : 'border-gray-300'
                  }`}>
                    {selectedAddress === index && (
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* طريقة الدفع */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-gray-800 mb-3">طريقة الدفع</h3>
          
          <div className="space-y-3">
            {paymentMethods.map((method, index) => (
              <div 
                key={method.id}
                className={`p-3 border rounded-lg cursor-pointer ${
                  selectedPayment === index ? 'border-green-500 bg-green-50' : 'border-gray-200'
                }`}
                onClick={() => setSelectedPayment(index)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3 space-x-reverse">
                    <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                      <i className={`${method.icon} text-lg text-gray-600`}></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-800">{method.title}</h4>
                      <p className="text-sm text-gray-500">{method.subtitle}</p>
                    </div>
                  </div>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    selectedPayment === index ? 'border-green-500' : 'border-gray-300'
                  }`}>
                    {selectedPayment === index && (
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ملاحظات إضافية */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-gray-800 mb-3">ملاحظات للمتجر</h3>
          <textarea
            placeholder="أضف أي ملاحظات خاصة بطلبك..."
            className="w-full p-3 border border-gray-200 rounded-lg text-sm resize-none"
            rows={3}
            maxLength={500}
          ></textarea>
        </div>

        {/* ملخص الطلب */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-gray-800 mb-3">ملخص الطلب</h3>
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">المجموع الفرعي</span>
              <span className="font-medium">{orderSummary.subtotal.toFixed(2)} ر.س</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-600">رسوم التوصيل</span>
              <span className="font-medium">{orderSummary.delivery.toFixed(2)} ر.س</span>
            </div>
            <div className="border-t border-gray-100 pt-2">
              <div className="flex justify-between">
                <span className="font-bold text-gray-800">المجموع الكلي</span>
                <span className="font-bold text-green-600 text-lg">{orderSummary.total.toFixed(2)} ر.س</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* زر تأكيد الطلب */}
      <div className="fixed bottom-16 left-4 right-4">
        <button
          onClick={handlePlaceOrder}
          className="w-full bg-green-500 text-white py-4 rounded-lg font-medium text-lg shadow-lg"
        >
          تأكيد الطلب - {orderSummary.total.toFixed(2)} ر.س
        </button>
      </div>

      {/* نموذج إضافة عنوان */}
      {showAddressForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
          <div className="bg-white w-full rounded-t-2xl p-4 max-h-96 overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold">إضافة عنوان جديد</h3>
              <button 
                onClick={() => setShowAddressForm(false)}
                className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            
            <div className="space-y-4">
              <input
                type="text"
                placeholder="عنوان المكان (منزل، عمل، إلخ)"
                className="w-full p-3 border border-gray-200 rounded-lg"
              />
              <input
                type="text"
                placeholder="العنوان التفصيلي"
                className="w-full p-3 border border-gray-200 rounded-lg"
              />
              <input
                type="tel"
                placeholder="رقم الهاتف"
                className="w-full p-3 border border-gray-200 rounded-lg"
              />
              <button
                onClick={() => setShowAddressForm(false)}
                className="w-full bg-green-500 text-white py-3 rounded-lg font-medium"
              >
                حفظ العنوان
              </button>
            </div>
          </div>
        </div>
      )}

      {/* شريط التنقل السفلي */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 h-16">
          <button 
            onClick={() => navigate('/home')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center text-gray-400">
            <i className="ri-search-line text-xl mb-1"></i>
            <span className="text-xs">البحث</span>
          </button>
          <button 
            onClick={() => navigate('/cart')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-shopping-cart-line text-xl mb-1"></i>
            <span className="text-xs">السلة</span>
          </button>
          <button 
            onClick={() => navigate('/orders')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-file-list-line text-xl mb-1"></i>
            <span className="text-xs">طلباتي</span>
          </button>
        </div>
      </div>
    </div>
  );
}